export default __webpack_public_path__ + "static/media/zarph_Z_logo_white.6fdbe86d.png";